var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#DDE7F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4445 19.8889C17.4445 21.1855 17.9596 22.429 18.8764 23.3459C19.7933 24.2627 21.0368 24.7778 22.3334 24.7778C23.63 24.7778 24.8735 24.2627 25.7904 23.3459C26.7072 22.429 27.2223 21.1855 27.2223 19.8889C27.2223 18.5923 26.7072 17.3488 25.7904 16.4319C24.8735 15.5151 23.63 15 22.3334 15C21.0368 15 19.7933 15.5151 18.8764 16.4319C17.9596 17.3488 17.4445 18.5923 17.4445 19.8889Z",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 36.9998V34.5554C15 33.2588 15.5151 32.0153 16.4319 31.0984C17.3488 30.1816 18.5923 29.6665 19.8889 29.6665H24.7778C26.0744 29.6665 27.3179 30.1816 28.2347 31.0984C29.1516 32.0153 29.6667 33.2588 29.6667 34.5554V36.9998",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8889 15.1587C31.9405 15.4279 32.8726 16.0395 33.5382 16.8971C34.2038 17.7546 34.5651 18.8093 34.5651 19.8948C34.5651 20.9803 34.2038 22.035 33.5382 22.8925C32.8726 23.7501 31.9405 24.3617 30.8889 24.6309",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37.0001V34.5557C36.9938 33.4766 36.6308 32.43 35.9675 31.5788C35.3043 30.7277 34.3781 30.1198 33.3333 29.8501",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.78078d902c3303e89411d6c3fd813f56.svg";
export { ForwardRef as ReactComponent };